import { removeLocal } from './local'

export default function logout(): void {
  // TODO: move to a better folder and implement cookie removal
  removeLocal(['refreshToken', 'token', 'isLoggedIn', 'user', 'permissions', 'estate'])

  // Clear all sessionStorage
  sessionStorage.clear()
  sessionStorage.clear()

  // redirect to login
  window.location.href = '/auth/login'
}
